import type { ReactNode } from 'react'

// Written out in full: Tailwind only generates classes it can read verbatim.
const CORNER = 'absolute h-[18%] w-[18%] border-trust-500 motion-safe:animate-breathe'
const CORNERS = [
  'left-0 top-0 rounded-tl-[clamp(12px,2vh,24px)] border-l-[clamp(3px,0.5vh,6px)] border-t-[clamp(3px,0.5vh,6px)]',
  'right-0 top-0 rounded-tr-[clamp(12px,2vh,24px)] border-r-[clamp(3px,0.5vh,6px)] border-t-[clamp(3px,0.5vh,6px)]',
  'bottom-0 left-0 rounded-bl-[clamp(12px,2vh,24px)] border-b-[clamp(3px,0.5vh,6px)] border-l-[clamp(3px,0.5vh,6px)]',
  'bottom-0 right-0 rounded-br-[clamp(12px,2vh,24px)] border-b-[clamp(3px,0.5vh,6px)] border-r-[clamp(3px,0.5vh,6px)]',
]

/** Blue corners around a QR, breathing: "point your phone here". */
export default function ScanFrame({ children }: { children: ReactNode }) {
  return (
    <div className="relative p-cfd-3">
      {CORNERS.map((position) => (
        <span key={position} className={`${CORNER} ${position}`} />
      ))}
      {children}
    </div>
  )
}
